module.exports = __webpack_public_path__ + "static/media/smart_01.f2aa8fde.png";